import Dropdown from "../common/dropdown/Dropdown";

const UNIT_LABELS = {
  K: "Thousand",
  L: "Lakh",
  Cr: "Crore",
};

export default function BudgetInput({
  label,
  value,
  unit,
  onValueChange,
  onUnitChange,
  error,
  required,
}) {
  return (
    <div className={`form-item ${error ? "has-error" : ""}`}>
      <label className="form-label">
        {label}
        {required && <span className="required">*</span>}
      </label>

      <div className="budget-input-wrapper d-flex align-center gap-2">
        {/* Number Input */}
        <input
          type="number"
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          className="form-input"
          placeholder="Enter amount"
        />

        {/* Your Custom Dropdown */}
        <Dropdown
          options={Object.keys(UNIT_LABELS)}
          value={unit}
          onChange={onUnitChange}
        />
      </div>

      {error && <p className="form-error">{error}</p>}
    </div>
  );
}